import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Container from 'reactstrap/lib/Container';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { SectionHeading } from 'site-modules/shared/components/editorial/section-heading/section-heading';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

export function ColumnList({ entry = DEFAULT_CONTENT }) {
  const title = entry.metadata('title').value();
  const columns = entry.children().map(column => ({
    htmlContent: column.metadata('column-html').value(),
  }));

  return (
    <div className="column-list small">
      <SectionHeading>{title}</SectionHeading>
      <Container>
        <Row>
          {columns.map((item, index) => (
            // no unique key, item contains htmlContent only
            <ContentFragment
              classes="column-list-html-content list-unstyled col-6 col-sm-3 my-1"
              componentToUse="ul"
              key={`key-${index}`} // eslint-disable-line
            >
              {item.htmlContent}
            </ContentFragment>
          ))}
        </Row>
      </Container>
    </div>
  );
}

ColumnList.propTypes = {
  entry: PropTypes.shape({
    metadata: PropTypes.func,
    children: PropTypes.func,
  }).isRequired,
};
